<template lang="html">
  <div>
    <member-restriction-item
      v-model="selectedItemId"
      :clone-id="cloneId"
    />
    <v-card
      v-if="!showItemOnly"
      :key="instanceKey"
    >
      <page-bar
        :title="pageTitle"
        :context-menu="defaultContextMenu"
        :loading="isDataLoading"
      />

      <api-errors :errors="errors" />

      <!-- LIST OF ITEMS -->
      <item-select-table
        :add-action="addNewItem"
        :add-label="'Add ' + type"
        :edit-action="editItem"
        :loading="!!isLoading"
        :search="true"
        :items="items"
        :pagination.sync="pagination"
        :total-items="totalListItems"
        :headers="headers"
      />
    </v-card>
  </div>
</template>

<script>
import {itemSelect} from '@/ft-vue-core'
import MemberRestrictionItem from './MemberRestrictionItem'

export default {
  name: 'MemberRestrictionList',
  components: {MemberRestrictionItem},
  mixins: [itemSelect],
  data: function () {
    return {
      type: 'Member Restriction',
      types: 'Member Restrictions',
      headers: [
        this.headerText('Restriction Name', 'name', true),
        this.headerText('Comments', 'notes', true),
        this.headerInvertedSwitch('Active', 'disabled')
      ],
      apiRecordCommand: 'memberRestriction'
    }
  },
  computed: {
  },
  methods: {
    // listCommandFilter (command) {
    //   return this.addCommandParamArray(command, 'include_fields', ['locationName', 'autoAssignable'])
    // }
  }
}
</script>
